module.exports = __webpack_public_path__ + "static/media/faccia_10.a4f04e6a.png";